<template>
  <div id="school-basic">
    <h4 class="sub-title">Basic Information</h4>
    <div class="name mt-4">
      <label for="name">Name:</label>
      <b-form-input
        name="name"
        type="text"
        id="school-name"
        v-model="school_name"
        required
        :state="nameInput"
      ></b-form-input>
    </div>
    <div id="type" class="dropdown mt-4">
      <label for="type">Type:</label>
      <br />
      <b-form-select v-model="type" name="type">
        <option disabled value>Select a School Type</option>
        <option value="Government">Government</option>
        <option value="Private">Private</option>
      </b-form-select>
    </div>
    <div class="emis-id mt-4">
      <label for="emis-id">EMIS ID:</label>
      <b-form-input
        name="emis-id"
        type="text"
        id="emis-id"
        v-model="emis_id"
        required
      ></b-form-input>
    </div>
    <!-- TODO: change to autocomplete -->
    <!-- <div class="trainer mt-4" v-cloak>
      <label for="trainer">Trainer: </label>
      <b-form-select name="trainer" type="text" id="trainer" v-model="trainer">
        <option disabled value="">Select a Trainer</option>
        <option v-for="trainer in allTrainers" :key="trainer._id" :value="trainer._id">{{ trainer.firstName}} {{ trainer.middleName }} {{ trainer.lastName }}</option>
      </b-form-select>
    </div>-->
  </div>
</template>

<script>
export default {
  name: 'SchoolBasic',
  computed: {
    school_name: {
      get() {
        return this.$store.state.schools.school.school_name;
      },
      set(val) {
        this.$store.commit('schools/school_name', val);
      },
    },
    nameInput() {
      return this.$store.state.schools.school.school_name.length > 2;
    },
    type: {
      get() {
        return this.$store.state.schools.school.type;
      },
      set(val) {
        this.$store.commit('schools/type', val);
      },
    },
    emis_id: {
      get() {
        return this.$store.state.schools.school.emis_id;
      },
      set(val) {
        this.$store.commit('schools/emis_id', val);
      },
    },
  },
};
</script>
